module Client.Domain.PageSkeleton

open Client.Domain.Navbar
open Fable.React.Props
open Fulma
open Fable.React
open Shared.Dto.User

let mySensFooter =
    footer [ ClassName "main-footer" ] [
        Columns.columns [
            Columns.IsCentered
            Columns.Modifiers [ Modifier.BackgroundColor IsLight ]
            Columns.IsGapless
        ] [
            Column.column [ Column.Width(Screen.All, Column.Is6) ] [
                Level.level [
                    Level.Level.Modifiers [
                        Modifier.Spacing(Spacing.PaddingTopAndBottom, Spacing.Is1)
                    ]
                ] [
                    Level.item [ Level.Item.HasTextCentered ] [
                        a [
                            Href "https://mysens.eu/datenschutzerklaerung-mysens-network/"
                            Target "_blank"
                        ] [ str "Datenschutzerklärung" ]
                    ]
                    Level.item [ Level.Item.HasTextCentered ] [
                        a [
                            Href "https://mysens.eu/nutzungsbedingungen-mysens-network/"
                            Target "_blank"
                        ] [ str "Nutzungsbedingungen" ]
                    ]
                    Level.item [ Level.Item.HasTextCentered ] [
                        a [
                            Href "https://mysens.eu/impressum-mysens-network/"
                            Target "_blank"
                        ] [ str "Impressum" ]
                    ]
                ]
            ]
        ]
    ]


let private elmishWrapper (content: ReactElement list) = div [ Id "elmish-wrapper" ] content

let skeleton dispatch (model: NavbarModel) (user: LoggedInUserDto) content =
    [
        navbar dispatch model user

        main [] content

        mySensFooter
    ]
    |> elmishWrapper

let skeletonOnlyNavbar dispatch (model: NavbarModel) (user: LoggedInUserDto) content =
    [
        navbar dispatch model user

        yield! content
    ]
    |> elmishWrapper

let centeredHeading (text: string) =
    Column.column [
        Column.Width(Screen.All, Column.IsNarrow)
        Column.Modifiers [
            Modifier.TextAlignment(Screen.All, TextAlignment.Centered)
        ]
    ] [ Heading.h3 [] [ str text ] ]

let headingOnlyPageContent (text: string) =
    Columns.columns [
        Columns.IsCentered
        Columns.Props [ Style [ Height "100%" ] ]
    ] [ centeredHeading text ]